<div *ngIf="date" class="data" [ngClass]="{ 'flex justify--end': alignLeft }">
  {{ date | dateAgo }}
</div>
